<footer class="sb-selection-menu-content-footer">
  <ng-content></ng-content>
</footer>
